import { RemoteAuthenticationMe } from 'data/usecases';
import { AuthenticationMeUseCaseInterface } from 'domain/usecases';
import { makeApiUrlAuthenticationMe } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAuthenticationMe =
  (): AuthenticationMeUseCaseInterface => {
    return new RemoteAuthenticationMe(
      makeApiUrlAuthenticationMe(),
      makeAxiosHttpClient(),
    );
  };
